<template>
  <div class="template-body">
    <!--面包屑部分-->
    <div class="ccui-navigation" ref="noPrintTop">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="purchaseBack"
        >返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/publicNotice/notice' }"
          >供货商管理
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/publicNotice/notice' }"
          >通知公告
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/publicNotice/notice' }"
          >通知公告
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="ccui-curr-crumb ccui-ml-10">
            查看
          </span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!--主体部分-->
    <div class="detail-box ccui-clearfix">
      <!--左边详情部分-->
      <div class="detail-info" style="position: relative;;min-height: 570px">
        <div class="box">
          <h3 style="cursor: default" :title="ruleForm.messageTitle">
            {{ ruleForm.messageTitle }}
          </h3>
          <span class="time">{{ ruleForm.sendTime }}</span>
          <div class="notifyContent" v-html="ruleForm.notifyContent"></div>
          <div
            class="downloadTitle"
            v-if="ruleForm.siteMessageFileBOS.length > 0"
            style="display: flex"
          >
            <span class="title">附件：</span>
            <detailDownload
              @downloadItem="downloadItem"
              :downloadLists="ruleForm.siteMessageFileBOS"
            />
          </div>
        </div>
      </div>

      <!--底部功能按钮-->
      <el-bottom-guide>
        <ul class="ccui-bottom-button" ref="noPrintBottom">
          <li>
            <el-button
              type="bottom"
              icon="icon-ccui-return"
              @click="purchaseBack"
              >返回
            </el-button>
          </li>
        </ul>
      </el-bottom-guide>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import { getArgs } from "@/basa/utils";
import { showErrorMessage, showLoading } from "@/basa/utils/public";
import { qrySiteMessageDetail, updateFirstDownloadTime } from "../api/all";
import detailDownload from "../components/detailDownload.vue";

export default {
  components: {
    detailDownload
  },
  data() {
    return {
      suppliersLists: [],
      dialogVisibleRemake: false,
      totalNum: 0,
      detailType: "",
      // 批文附件上传
      tableKey: 0,
      tabShow: 1,
      uploadLoading: null,
      fileList: [],
      uploadList: [],
      checked: {
        isNotifyAll: {
          isNotifyAll1: false,
          isNotifyAll2: false
        },
        notifyTimeType: {
          notifyTimeType1: false,
          notifyTimeType2: false
        }
      },
      selectOptions: {
        notifyType: [
          {
            label: "发送通知",
            value: 1
          },
          {
            label: "政策公告",
            value: 2
          },
          {
            label: "文件文档",
            value: 3
          }
        ],
        notifyTimeType: [
          {
            label: "实时推送",
            value: 1
          },
          {
            label: "定时推送",
            value: 2
          }
        ]
      },
      detailSearch: "",
      tableDataSupplierLoading: false,
      tabButton: [
        {
          value: 1,
          label: "详情"
        },
        {
          value: 2,
          label: "日志"
        }
      ],
      // 基本信息
      baseInfoBack: [
        {
          value: "messageTitle",
          label: "标题",
          row: 12,
          isMust: true
        },
        {
          value: "messageStatus",
          label: "发布状态",
          row: 12,
          isMust: true,
          type: "messageStatus"
        },
        {
          value: "notifyType",
          label: "通知形式",
          row: 12,
          isMust: true,
          type: "notifyType"
        },
        {
          value: "appNames",
          label: "通知应用",
          row: 12,
          isMust: true
        },
        {
          value: "createUserName",
          label: "创建人",
          row: 12,
          isMust: true
        },
        {
          value: "revokeUserName",
          label: "撤回人",
          row: 12,
          isMust: true
        },
        {
          value: "notifyTimeType",
          label: "通知时间",
          row: 12,
          isMust: true,
          type: "notifyTimeType"
        },
        {
          value: "isNotifyAll",
          label: "通知对象",
          row: 12,
          isMust: true,
          type: "isNotifyAll"
        },
        {
          value: "revokeTime",
          label: "撤回时间",
          row: 12,
          isMust: true
        },
        {
          value: "createTime",
          label: "创建时间",
          row: 12,
          isMust: true
        }
      ],
      baseInfo: [
        {
          value: "messageTitle",
          label: "标题",
          row: 12,
          isMust: true
        },
        {
          value: "messageStatus",
          label: "发布状态",
          row: 12,
          isMust: true,
          type: "messageStatus"
        },
        {
          value: "notifyType",
          label: "通知形式",
          row: 12,
          isMust: true,
          type: "notifyType"
        },
        {
          value: "appNames",
          label: "通知应用",
          row: 12,
          isMust: true
        },
        {
          value: "createUserName",
          label: "创建人",
          row: 12,
          isMust: true
        },
        {
          value: "notifyTimeType",
          label: "通知时间",
          row: 12,
          isMust: true,
          type: "notifyTimeType"
        },
        {
          value: "isNotifyAll",
          label: "通知对象",
          row: 12,
          isMust: true,
          type: "isNotifyAll"
        },
        {
          value: "createTime",
          label: "创建时间",
          row: 12,
          isMust: true
        }
      ],
      dialogVisible: false,
      formSupplier: {
        pageNo: 1,
        pageSize: 10
      },
      tableDataSupplier: [],
      ruleForm: {
        messageTitle: null,
        notifyTimeType: null,
        isNotifyAll: null,
        messageSubtitle: null,
        notifyType: null,
        notifyContent: null,
        siteMessageFileBOS: [],
        siteMessageSupplierBOS: [],
        notifyTime: null
      },
      rules: {
        notifyType: {
          required: true,
          message: "请选择通知类型",
          trigger: "change"
        },
        notifyTimeType: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择通知时间类型"));
              } else if (value === 2 && !this.ruleForm.notifyTime) {
                callback(new Error("请选择定时推送的具体时间"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"] // 仅在失去焦点时触发
          }
        ],
        notifyContent: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(" "));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        messageTitle: {
          required: true,
          message: "请输入标题",
          trigger: "change"
        },
        desc: { required: true, message: "", trigger: "change" },
        isNotifyAll: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择通知对象"));
              } else if (
                value === 2 &&
                this.ruleForm.siteMessageSupplierBOS === "请选择"
              ) {
                callback(new Error("请选择指定供应商"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      editorText: "", // 双向同步的变量
      agentId: getArgs("a"),
      editorTextCopy: "",
      headers: {
        Authorization: Cookies.get("access_token") || "",
        APP_TOKEN: localStorage.appToken || ""
      },
      uploadParams: {
        agentId: getArgs("a")
      },
      createUserName: "",
      selectionChange: [],
      siteMessageSupplierBOS: "请选择"
    };
  },
  computed: {
    getUploadFileRules() {
      return [".pdf", ".jpg", ".docx", ".doc"];
    }
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      qrySiteMessageDetail({
        messageId: this.$route.query.messageId,
        isShowPageLoading: true,
        tabId: 1
      }).then(res => {
        if (res.data.code == "0") {
          this.ruleForm = res.data.data;
        }
        if (this.$route.query.type === "edit") {
          this.createUserName = this.ruleForm.createUserName;
          this.checked.isNotifyAll[
            `isNotifyAll${this.ruleForm.isNotifyAll}`
          ] = true;
          this.checked.notifyTimeType[
            `notifyTimeType${this.ruleForm.notifyTimeType}`
          ] = true;
          this.editorText = this.ruleForm.notifyContent;
          this.siteMessageSupplierBOS =
            this.ruleForm.siteMessageSupplierBOS.length > 0
              ? this.ruleForm.siteMessageSupplierBOS
                  .map(item => item.supplierName) // 提取 supplierName
                  .join(",")
              : "请选择";
        }
      });
    },
    // 日志
    supplierMessageInit() {},
    downloadItem(item) {
      updateFirstDownloadTime({ messageId: this.ruleForm.messageId }).then(
        res => {
          if (res.data.code == "0") {
            window.open(
              this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
                "/apis/sgmp/oc/downloadByUploadId?uploadId=" +
                item.uploadId +
                "&isSecret=0"
            );
          }
        }
      );
    },
    exportData() {
      // this.loadingInstance = this.$loading({
      //   lock: true,
      //   text: "导出中，请稍后...",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0)"
      // });
      // const api = querySupplierMessageExport;
      // api({
      //   supplierName: this.detailSearch,
      //   messageId: this.ruleForm.messageId
      // }).then(res => {
      //   // console.log(res);
      //   let blob = new Blob([res.data], {
      //     type:
      //       "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      //   });
      //
      //   if (window.navigator.msSaveOrOpenBlob) {
      //     navigator.msSaveBlob(blob);
      //   } else {
      //     let elink = document.createElement("a");
      //     if (
      //       res.headers["content-disposition"] &&
      //       res.headers["content-disposition"].split(";").length > 1 &&
      //       res.headers["content-disposition"].split(";")[1].split("filename=")
      //         .length > 1
      //     ) {
      //       let filename = res.headers["content-disposition"]
      //         .split(";")[1]
      //         .split("filename=")[1];
      //       filename = window.decodeURIComponent(filename);
      //       // filename = filename.split("utf-8''")[1];
      //       // console.log(filename);
      //       elink.download = filename;
      //     }
      //     elink.style.display = "none";
      //     elink.href = URL.createObjectURL(blob);
      //     document.body.appendChild(elink);
      //     elink.click();
      //     document.body.removeChild(elink);
      //   }
      //   this.loadingInstance.close();
      // querySupplierMessageExport({
      //   supplierName: this.detailSearch,
      //   messageId: this.ruleForm.messageId
      // }).then(res => {
      //   if (res.data.code == 0) {
      //     let a = document.createElement("a");
      //     a.style.display = "none";
      //     a.href = `${addUrlPerFix(
      //       process.env.VUE_APP_BASE_URL
      //     )}/apis/emma/file/downloadByUploadId?uploadId=${
      //       res.data.data.fileInfoRspBO.uploadId
      //     }`;
      //     a.setAttribute("download", res.data.data.fileInfoRspBO.fileName);
      //     document.body.appendChild(a);
      //     a.click();
      //   }
      // });
      // });
    },
    tabChange(item) {
      this.tabShow = item.value;
      localStorage.setItem("issueTable", this.tabShow);
    },
    triggerUpload() {
      // 获取 el-upload 内部的隐藏 input[type="file"]
      const uploadInput = this.$refs.fileUploader.$el.querySelector(
        "input[type='file']"
      );
      if (uploadInput) {
        uploadInput.click(); // 手动触发点击
      }
    },
    filteredOptions() {
      const optionsMap = {
        create: [this.optionButton[0], this.optionButton[1]],
        edit: [this.optionButton[0], this.optionButton[1]],
        detail: this.ruleForm.canRevoke === 1 ? [this.optionButton[2]] : []
      };

      return optionsMap[this.$route.query.type] || [];
    },

    handleCloseRemake() {
      this.dialogVisibleRemake = false;
    },
    purchaseBack() {
      this.$router.go(-1);
    },
    handleCheckbox(value, type) {
      if (value === 1) {
        this.checked[type][type + "2"] = false;
        this.ruleForm.siteMessageSupplierBOS = [];
        this.siteMessageSupplierBOS = "请选择";
        this.ruleForm[type] = "";
      } else {
        console.log(type);
        this.checked[type][type + "1"] = false;
        this.ruleForm.siteMessageSupplierBOS = [];
        this.siteMessageSupplierBOS = "请选择";
        this.ruleForm[type] = "";
      }
      this.ruleForm[type] = value;
    },
    afterChange() {
      console.log(this.editorText, "change");
    },
    selectedFile($event) {
      const file = $event.target.files[0];
      // 把图片上传到后端服务器 拿到url  uploadImage 是自己后端上传图片的接口
      // 调用appendHtml方法把图片追加到富文本
      // const url= await  uploadImage (file)
      console.log(file, $event, "ccccccccccccccccccccccc");
    },
    // getJSON() {
    //   console.log(this.$refs.elKindeditor);
    //   let getDomJson = this.$refs.elKindeditor.getChildrenJSON(
    //     window.KindEditor("#editor_id").text()
    //   );
    //   this.transitionData = getDomJson;
    //   console.log("getDomJson", getDomJson);
    // },
    // transition() {
    //   this.getJSON();
    // },
    onContentChange(val, empty) {
      this.ruleForm.notifyContent = val;
      this.$refs.ruleForm.validateField("notifyContent");
      this.editorTextCopy = val;
    },
    onSuccess({ message, data }) {
      this.$message({
        showClose: true,
        message: "附件上传成功",
        ccuiCustom: true,
        offset: document.documentElement.clientHeight / 2 - 21,
        type: "success"
      });
      let [{ uploadId, fileName, fileSize, downloadUrl }] = data;
      const obj = {
        uploadId,
        fileName: fileName,
        fileSize: fileSize,
        fileUrl: downloadUrl
      };

      this.ruleForm.siteMessageFileBOS.push(obj);
      let o = JSON.parse(JSON.stringify(obj));
      delete o.createTime;
      this.uploadList.push(o);
      this.uploadLoading.close();
      // console.log(o);
    },
    onSuccessKindeditor({ message, data }) {
      this.$message({
        showClose: true,
        message: "附件上传成功",
        ccuiCustom: true,
        offset: document.documentElement.clientHeight / 2 - 21,
        type: "success"
      });

      let [{ uploadId, downloadUrl }] = data;

      this.editorText +=
        '<img src="' + downloadUrl + '" alt="' + uploadId + '" />' + "<br/>";
      this.ruleForm.notifyContent = this.editorText;
      this.uploadLoading.close();
    },

    onError({ message }) {
      showErrorMessage("附件上传失败");
      this.uploadLoading.close();
    },
    onProgress(file, fileList) {
      if (file.status == "ready") {
        this.uploadLoading = showLoading("上传中");
      }
    },
    beforeUpload({ name, size }) {
      const suffix = name.substring(name.lastIndexOf("."));
      // console.log("suffix", suffix);
      let fileType = this.getUploadFileRules.includes(suffix);
      let fileSize = size > 20 * 1024 * 1024;

      if (!fileType) {
        showErrorMessage("上传文件格式错误！");
        this.uploadLoading.close();
      } else if (fileSize) {
        showErrorMessage("文件大小不可超过20M！");
        this.uploadLoading.close();
      }

      return fileType && !fileSize;
    },
    deleteDownload(item) {
      // 找到当前项在数组中的索引
      const index = this.ruleForm.siteMessageFileBOS.findIndex(
        file => file.uploadId === item.uploadId
      );
      if (index !== -1) {
        // 删除该项
        this.ruleForm.siteMessageFileBOS.splice(index, 1);
      }
    },
    handleSupplier() {
      if (this.ruleForm.isNotifyAll === 2) {
        this.dialogVisible = true;
        this.getSupplier(this.formSupplier);
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    onSubmit() {
      this.getSupplier(this.formSupplier);
    },
    onCancel() {
      let arr = this.formSupplier;
      this.formSupplier = {
        pageNo: 1,
        pageSize: arr.pageSize
      };
    },
    handleClickSupplier(row, e) {
      const arr = this.ruleForm.siteMessageSupplierBOS.some(
        existingItem => existingItem.vendorOrgId === row.vendorOrgId
      );
      if (!arr) {
        this.ruleForm.siteMessageSupplierBOS.push(row);
        this.dialogVisible = false;
      }
    },

    handlePrev() {},
    // 下一页
    handleNext() {},
    handleSizeChange(val) {
      this.formSupplier.pageNo = 1;
      this.formSupplier.pageSize = val;
      // setSessionItem("pageSize", this.tableName, val);
      this.getSupplier(this.formSupplier);
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.formSupplier.pageNo = val;
      this.getSupplier(this.formSupplier);
    },
    getSupplier(form) {
      // 供应商列表接口
      this.tableDataSupplierLoading = true;
    },
    handleSelectionChange(val) {
      this.selectionChange = val;
    },
    selectBusiness() {
      // 深拷贝 selectionChange，避免对原始数据造成影响
      const processedSelection = this.selectionChange.map(item => {
        // 复制对象并移除 vendorNameCn
        const { vendorNameCn, ...rest } = item;
        return {
          ...rest,
          supplierName: vendorNameCn // 使用 vendorNameCn 的值
        };
      });

      // 更新 ruleForm.siteMessageSupplierBOS
      this.ruleForm.siteMessageSupplierBOS = processedSelection;

      // 将 supplierName 拼接成字符串
      this.siteMessageSupplierBOS = processedSelection
        .map(item => item.supplierName) // 提取 supplierName
        .join(","); // 用逗号拼接

      // 关闭弹窗
      this.dialogVisible = false;
    },
    handleCloseSupplier() {
      this.formSupplier = {
        pageNo: 1,
        pageSize: 10
      };
      this.dialogVisible = false;
    }
  },
  deactivated() {}
};
</script>

<style lang="scss" scoped>
.detailSearch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  margin-bottom: 10px;
}

/deep/ .el-col-4 {
  width: 15.66667%;
  // padding-top: 5px;
}

.red {
  border: 1px solid #ff142f;
  color: #ff142f !important;
  display: inline-block;
  margin-right: 5px;
}

/deep/ .readonly .el-input__inner {
  cursor: pointer !important;
}

.detail-react {
  overflow: hidden;
  float: left;
  margin: 0px 0 0 18px;
  width: 29.69%;

  .detail-title {
    overflow: hidden;
    padding: 0 20px 0 20px;

    /deep/ .el-card-title {
      .details-title {
        top: 0;
        width: 56px !important;
        // width: 10%;
      }
    }

    .approval-process {
      margin-top: 16px;
    }
  }

  /deep/ .el-dialog__headerbtn {
    z-index: 20 !important;
  }

  ///deep/.el-dialog--customize .el-dialog__body.el-dialog--customize__body {
  //  text-align: left;
  //}

  .readingRecords {
    width: 335px;
    background: red;
    margin: 20px 22px 20px 24px;

    /deep/ .el-table__header-wrapper {
      thead {
        tr {
          th {
            padding: 8px 0 7px 0;
            border-right: 1px solid #f1f1f1;
            border-top: 1px solid #d8d8d8;
            border-bottom: 1px solid #d8d8d8;

            .cell {
              font-size: 13px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(74, 74, 74, 1);
            }
          }

          th:nth-of-type(3) {
            border-right: none;
          }
        }
      }
    }

    //
    ///deep/ .el-table__body-wrapper {
    //  tbody {
    //    tr {
    //      td {
    //        border-right: 1px solid #f1f1f1;
    //
    //        .cell {
    //          font-size: 13px;
    //          font-family: PingFangSC-Regular;
    //          font-weight: 400;
    //        }
    //      }
    //
    //      td:last-child {
    //        border-right: none;
    //      }
    //    }
    //  }
    //}
  }
}

.selectNotifyAll {
  cursor: pointer;
  display: inline-block;
  background-color: #fff;
}

.unSelectNotifyAll {
  cursor: not-allowed;
  display: inline-block;
  background-color: #e5e5e5;
}

/deep/ .el-table thead {
  font-size: 13px;
}

/deep/ .el-col-24 {
  width: 85%;
}

.el-col-width {
  width: 80px;
  // width: 10%;
}

/deep/ .el-table tr {
  //height: 46px !important;
}

/deep/ .el-table th {
  padding: 3px 0 !important;
}
/deep/.ccui-multifunctional-table-wrapper .el-table thead tr th .cell {
  height: 30px !important;
  line-height: 30px !important;
}

.bodyText {
  font-weight: 400;
  font-size: 13px;
  color: #4a4a4a;
  margin-bottom: 20px;
}

.bodyTextPadding {
  margin-right: 30px;
}

.price {
  color: #fff;
  font-size: 12px;
  background: #47b548;
  padding: 0 5px;
  height: 16px;
  line-height: 16px;
  border-radius: 2px;
}

///deep/ .el-table .cell {
//  padding: 5px 10px;
//}

/deep/ .el-table__row {
  font-size: 13px;
}

.negative {
  color: #ff142f;
}

.positive {
  color: #29a847;
}

.cancelIcons {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #fff;
  cursor: pointer;
}

.download {
  margin-top: 10px;
  background: #f6f6f6;
  color: #4a4a4a;
}

.selectSeekSupplierQuotes {
  cursor: pointer;
  width: 14px;
  height: 14px;
  border: 1px solid #999;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selectSeekSupplierQuotesRed {
  cursor: pointer;
  width: 14px;
  height: 14px;
  border: 1px solid red;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selectSeekSupplierQuotesBowel {
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 5px;
}

.selectSeekSupplierQuotesBowelRed {
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: red;
  border-radius: 5px;
}

.selectSeekSupplierQuotesDis {
  width: 14px;
  height: 14px;
  border: 1px solid #999;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: unset;
}

.selectSeekSupplierQuotesBowelDis {
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: #999;
  border-radius: 5px;
  cursor: unset;
}

/deep/ .highlighted-cell {
  background-color: rgba(353, 92, 100, 0.3) !important; /* 高亮背景色 */
}

/deep/ .el-textarea {
  border: 1px solid #edf2fc !important;
}

/deep/ .detail-info {
  margin-top: 15px;
  width: 100% !important;
  background: #fff;
  margin-bottom: 90px;
}
.box {
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  h3 {
    flex: 1;
    font-weight: 600;
    font-size: 22px;
    color: #4a4a4a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
  }
  .time {
    font-weight: 400;
    font-size: 13px;
    color: #9b9b9b;
    display: inline-block;
    margin-bottom: 15px;
  }
  .notifyContent {
    margin-bottom: 40px;
  }
  .downloadTitle {
    .title {
      font-weight: 400;
      font-size: 13px;
      color: #4a4a4a;
    }
  }
}
.text-clamp {
  display: inline-block; /* 保证宽度生效 */
  max-width: 200px; /* 最大宽度为 200px */
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>
<style lang="scss">
.el-menu--horizontal > .el-menu-item:hover {
  background-color: transparent;
}
</style>
